import { Reveal, SectionHead, Em } from "@/components/Reveal";

const stages = [
  { n: "01", k: "VISION", t: "SEE WHAT YOU ACTUALLY WANT.", d: "Strip away the shoulds, borrowed goals and acceptable dreams. What would you choose if you stopped editing your desire?" },
  { n: "02", k: "BLUEPRINT", t: "DESIGN THE LIFE THAT CAN HOLD IT.", d: "Turn desire into decisions, priorities and an actual blueprint for the life you’re building." },
  { n: "03", k: "QUANTUM HABITS", t: "BECOME HER DAILY.", d: "Install 7 daily rituals that make your future identity your practiced identity." },
  { n: "04", k: "CAPACITY", t: "LEARN TO HOLD MORE.", d: "More visibility. More love. More responsibility. More pleasure. More money. More LIFE." },
  { n: "05", k: "CURRENCY", t: "TURN WHAT’S INSIDE YOU INTO SOMETHING REAL.", d: "Ideas become creations. Creativity becomes impact. Decisions become movement. Value becomes money. Vision becomes life." },
];

export const ShiftSection = () => (
  <section data-testid="shift-section" className="mx-auto max-w-6xl px-5 py-20 sm:py-28">
    <SectionHead eyebrow="THE WILD WOMAN METHOD™">
      VISION BECOMES LIFE
      <br />
      WHEN YOU <Em>PRACTICE IT.</Em>
    </SectionHead>

    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="shift-cards">
      {stages.map((c, i) => (
        <Reveal key={c.n} delay={i * 0.06} className={i === 4 ? "sm:col-span-2 lg:col-span-1" : ""}>
          <div className="group h-full border border-white/10 bg-card p-6 transition-all duration-300 hover:-translate-y-1 hover:border-lime/50 sm:p-8">
            <p className="font-mono text-xs tracking-[0.3em] text-lime">
              {c.n} <span className="text-cream/40">/ {c.k}</span>
            </p>
            <h3 className="mt-4 text-xl font-extrabold tracking-tight text-cream sm:text-2xl">{c.t}</h3>
            <p className="mt-3 text-sm leading-relaxed text-cream/60">{c.d}</p>
          </div>
        </Reveal>
      ))}
    </div>

    <Reveal className="mt-20 text-center">
      <p className="text-3xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
        VISION BECOMES <span className="font-serif italic font-medium text-lime">CAPACITY.</span>
      </p>
      <p className="mt-2 text-3xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
        CAPACITY BECOMES <span className="font-serif italic font-medium text-lime">CURRENCY.</span>
      </p>
    </Reveal>
  </section>
);
